import React, { FC } from "react";
import { Provider } from "react-redux";
import Page from "layout/Page/Page";
import config from "../package.json";
import "styles/index.scss";
import "react-datepicker/dist/react-datepicker.css";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AppProps } from "next/app";
import { Store } from "redux";

import withReduxStore from "utils/withRedux";

interface IProps extends AppProps {
  reduxStore: Store;
}

const ClearChoice: FC<IProps> = ({ Component, pageProps, reduxStore }) => {
    console.log(`%cVersion: ${config.version}`, "color:white;font-size:22px");
    return (
    <Provider store={reduxStore}>
      <Page>
        <Component {...pageProps} />
      </Page>
    </Provider>
    );
};

export default withReduxStore(ClearChoice);
